import { FunctionComponent, ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppState, Auth0Provider } from '@auth0/auth0-react';

interface Auth0Config {
  domain: string;
  clientId: string;
  redirectUri: string;
  audience: string;
  returnTo: string;
}

interface Props extends Auth0Config {
  children: ReactNode;
}

const Auth0ProviderWithHistory: FunctionComponent<Props> = ({
  children,
  ...props
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const auth0Props = {
    ...props,
    onRedirectCallback: (appState?: AppState) => {
      navigate({
        pathname: location.pathname,
        search: appState?.search
      });
    }
  };

  return <Auth0Provider {...auth0Props}>{children}</Auth0Provider>;
};

export default Auth0ProviderWithHistory;
